import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Picture } from 'components/Picture';
import AIMS_FLAVORS from 'lib/aimsFlavors';
import styles from './promotionalStyles.module.scss';

/**
  * PromotionalMedia component renders a list of media items with a selection feature.
  * @param {object} props
  * @param {Array} props.media - The list of media items.
  * @param {Function} props.selectMedia - Function to select a media item.
  * @param {object} props.additionalStyles - Additional styles for the component.
  * @param {number} props.selectedIdx - The index of the selected media item.
  * @param {boolean} props.isMobile - Indicates if the component is rendered on mobile.
 */
const PromotionalMedia = ({
  media,
  selectMedia,
  additionalStyles,
  selectedIdx,
  isMobile,
}) => (
  <div className="df justify-start">
    <ul className={classNames(styles.mediaContainer, additionalStyles.container)}>
      {media.map(({ url }, idx) => (
        <li
          className={classNames(
            styles.mediaItem,
            additionalStyles.item,
            { [styles.mobile]: isMobile },
          )}
          data-test="promotional-media-item"
          data-testid="promotional-media-item"
          key={url.primary}
        >
          <button
            type="button"
            onClick={() => selectMedia(url.primary, idx)}
            className={classNames({ [styles.selected]: idx === selectedIdx }, 'css-reset-btn')}
          >
            <Picture
              url={url.primary}
              responsiveFlavors={{ s: AIMS_FLAVORS.FOCAL_260x260 }}
              flavor="focal"
            />
          </button>
        </li>
      ))}
    </ul>
  </div>
);

PromotionalMedia.propTypes = {
  media: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.shape({ primary: PropTypes.string }),
    }),
  ).isRequired,
  selectMedia: PropTypes.func,
  additionalStyles: PropTypes.shape({
    container: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.bool,
    ]),
    item: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.bool,
    ]),
  }),
  selectedIdx: PropTypes.number,
  isMobile: PropTypes.bool,
};

PromotionalMedia.defaultProps = {
  additionalStyles: {},
  selectedIdx: -1,
  selectMedia: Function.prototype,
  isMobile: false,
};

export { PromotionalMedia };
